import {
  IconFacebook,
  IconInstagram,
  IconLinkedin,
  IconTiktok,
  IconYoutube,
  LogoSpiderTrader,
  LogoSpiderTraderColor,
} from "../../assets";
import { IClient } from "..";

export const SpiderTrader: IClient = {
  colors: {
    primary: [
      "#154BB6", //0
      "#3F87F4", //1
      "#319CE6", //2
      "#1239A6", //3
      "#1B40A8", //4
    ],
    primaryOpacity: [
      "#E7E9EC", //0
      "#ECF3FE", //1
      "#EAF5FC", //2
      "#E8F5EC", //3
      "#154BB620", //4
    ],
    complementary: [
      "#169C3C", //0
      "#2C1B73", //1
      "#E3183B", //2
      "#8131E6", //3
      "#FB6815", //4
      "#EB49EE", //5
      "#319CE6", //6
      "#5E71D7", //7
    ],
    complementaryOpacity: [
      "#E8F5EC", //0
      "#EAE8F1", //1
      "#FCE8EB", //2
      "#F2EAFC", //3
      "#FFEEDE", //4
      "#FDEDFD", //5
      "#EAF5FC", //6
      "#EAF0FC", //7
    ],
    basic: [
      "#FFFFFF", //0
      "#F0F0F0", //1
      "#D7D7D7", //2
      "#B2B1B1", //3
      "#6B6B6B", //4
      "#2F2F2F", //5
    ],
    other: [
      "#FAFBFE", //0
      "#B9B9B9", //1
      "#1D3461", //2
      "#154BB6", //3
      "#DEDEDE", //4
      "#B3B1B1", //5
    ],
    alerts: [
      "#F43333", //0
      "#FAAB36", //1
      "#23BD32", //2
      "#EB4747", //3
    ],
    alertsOpacity: [
      "#FEEBEB", //0
      "#FEF7EB", //1
      "#E9F8EB", //2
    ],
  },
  image: {
    logo: LogoSpiderTrader,
    icon: LogoSpiderTrader,
    icon2: LogoSpiderTraderColor,
    logo2: LogoSpiderTraderColor,
  },
  address: {
    street: "Avenida Brigadeiro Faria Lima",
    number: "3144",
    neighborhood: "Jardim Paulistano",
    complement: "3º Andar",
    city: "São Paulo",
    state: "SP",
    country: "Brasil",
    zipcode: "01451-000",
  },
  name: "SpiderTrader",
  title: "SpiderTrader",
  favicon: "favicon-spidertrader.ico",
  description:
    "SpiderTrader - Plataforma de trading e gestão de investimentos. Marketplace de estratégias e operações automatizadas.",
  acceptLanguage: ["pt-BR"],
  redirect: "/marketplace",
  autoRegister: true,
  hasBrokers: true,
  hasCancelButton: true,
  hasClarity: true,
  hasFinancial: true,
  email: {
    email: "global.footer.email",
    link: "https://atendimento.traderevolution.com.br/form/3983/",
  },
  terms: {
    pt_br: "https://spidertrader.com.br/termo-de-uso-do-site-e-aplicativos/",
    en_us: "https://spidertrader.com.br/en/terms-of-use/",
    es: "https://spidertrader.com.br/termo-de-uso-do-site-e-aplicativos/",
  },
  privacyPolicy: {
    pt_br:
      "https://spidertrader.com.br/politica-de-privacidade-de-dados-pessoais",
    en_us: "https://spidertrader.com.br/en/privacy-policy/",
    es: "https://spidertrader.com.br/es/politica-de-privacidad-de-datos-personales/",
  },
  footerLinksTerms: [
    {
      path: {
        pt_br:
          "https://spidertrader.com.br/politica-de-privacidade-de-dados-pessoais",
        en_us: "https://spidertrader.com.br/en/privacy-policy/",
        es: "https://spidertrader.com.br/es/politica-de-privacidad-de-datos-personales/",
      },
      name: "global.routes_names.privacy_policy",
    },
    {
      path: {
        pt_br:
          "https://spidertrader.com.br/termo-de-uso-do-site-e-aplicativos/",
        en_us: "https://spidertrader.com.br/en/terms-of-use/",
        es: "https://spidertrader.com.br/es/condiciones-de-uso/",
      },
      name: "global.routes_names.terms_of_use",
    },
  ],
  navbarLinksDefault: [
    {
      name: "global.routes_names.home",
      path: "https://spidertrader.com.br/home/",
      blank: true,
    },
    {
      name: "global.routes_names.products",
      path: "https://spidertrader.com.br/serviços/",
      blank: true,
    },
    {
      name: "global.routes_names.marketplace",
      path: "/marketplace",
      // subLinks: [
      //   {
      //     name: "global.routes_names.marketplace_highlights",
      //     path: "/marketplace",
      //   },
      //   {
      //     name: "global.routes_names.marketplace_CopyOrder",
      //     path: "/marketplace/copyorder",
      //   },
      // ],
    },
    {
      name: "global.routes_names.broker",
      path: "https://spidertrader.com.br/corretoras/",
      blank: true,
    },
    {
      name: "global.routes_names.help_center",
      path: "https://spidertrader.com.br/central-de-ajuda/",
      blank: true,
    },
  ],
  navbarLinksClient: [
    {
      name: "global.routes_names.home",
      path: "https://spidertrader.com.br/home/",
      blank: true,
    },
    {
      name: "global.routes_names.products",
      path: "https://spidertrader.com.br/serviços/",
      blank: true,
    },
    {
      name: "global.routes_names.marketplace",
      path: "/marketplace",
      // subLinks: [
      //   {
      //     name: "global.routes_names.marketplace_highlights",
      //     path: "/marketplace",
      //   },
      //   {
      //     name: "global.routes_names.marketplace_CopyOrder",
      //     path: "/marketplace/copyorder",
      //   },
      // ],
    },
    {
      name: "global.routes_names.broker",
      path: "https://spidertrader.com.br/corretoras/",
      blank: true,
    },
    {
      name: "global.routes_names.help_center",
      path: "https://spidertrader.com.br/central-de-ajuda/",
      blank: true,
    },
    {
      name: "global.routes_names.my_portfolio",
      path: "/meu-portfolio",
      subLinks: [
        {
          name: "global.routes_names.my_portfolio_purchases",
          path: "/meu-portfolio/minhas-compras",
        },
      ],
    },
    {
      name: "global.routes_names.operations",
      path: "/operacoes",
      subLinks: [
        {
          name: "global.routes_names.operations_performance",
          path: "/operacoes/desempenho",
        },
        {
          name: "global.routes_names.operations_positions",
          path: "/operacoes/posicoes",
        },
        {
          name: "global.routes_names.operations_orders",
          path: "/operacoes/ordens",
        },
      ],
    },
  ],
  navbarLinksAnalyst: [
    {
      name: "global.routes_names.home",
      path: "https://spidertrader.com.br/home/",
      blank: true,
    },
    {
      name: "global.routes_names.products",
      path: "https://spidertrader.com.br/serviços/",
      blank: true,
    },
    {
      name: "global.routes_names.marketplace",
      path: "/marketplace",
      // subLinks: [
      //   {
      //     name: "global.routes_names.marketplace_highlights",
      //     path: "/marketplace",
      //   },
      //   {
      //     name: "global.routes_names.marketplace_CopyOrder",
      //     path: "/marketplace/copyorder",
      //   },
      //   {
      //     name: "global.routes_names.marketplace_SmartCopy",
      //     path: "/marketplace/smartcopy",
      //   },
      // ],
    },
    {
      name: "global.routes_names.broker",
      path: "https://spidertrader.com.br/corretoras/",
      blank: true,
    },
    {
      name: "global.routes_names.help_center",
      path: "https://spidertrader.com.br/central-de-ajuda/",
      blank: true,
    },
    {
      name: "global.routes_names.my_portfolio",
      path: "/meu-portfolio",
      subLinks: [
        {
          name: "global.routes_names.my_portfolio_products",
          path: "/meu-portfolio/meus-servicos",
        },
      ],
    },
    {
      name: "global.routes_names.operations",
      path: "/operacoes",
      subLinks: [
        // {
        //   name: "global.routes_names.operations_performance",
        //   path: "/operacoes/desempenho",
        // },
        {
          name: "global.routes_names.operations_positions",
          path: "/operacoes/posicoes",
        },
        {
          name: "global.routes_names.operations_orders",
          path: "/operacoes/ordens",
        },
      ],
    },
  ],
  socialLinks: [
    {
      path: "https://www.instagram.com/spider_traderofc",
      icon: IconInstagram,
      name: "Instagram",
    },
    {
      path: "https://www.youtube.com/@SpiderTrader",
      icon: IconYoutube,
      name: "Youtube",
    },
    {
      path: "https://www.linkedin.com/company/spider-trader/",
      icon: IconLinkedin,
      name: "Linkedin",
    },
    {
      path: "https://www.facebook.com/profile.php?id=61558650295386&sk=about",
      icon: IconFacebook,
      name: "Facebook",
    },
    {
      path: "https://www.tiktok.com/@spidertrader_ofc",
      icon: IconTiktok,
      name: "Tiktok",
    },
  ],
};
